import { render, staticRenderFns } from "./AvaliationLikertSacaleChart.vue?vue&type=template&id=6d284b30"
import script from "./AvaliationLikertSacaleChart.vue?vue&type=script&lang=js"
export * from "./AvaliationLikertSacaleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports